import { UIDAPresentationTypeEnum, type KuxFilteredCategoriesDTO } from '../compat/tvpil';

const logoInAppLink = 'hideTitleForLogoRail';

/**
 * @see https://kaltura.atlassian.net/wiki/spaces/XTVEXT/pages/4004348029/HBO+MAX+FE+configuration+part#HBO-MAX-page
 */
export function isLogoWidget(category: KuxFilteredCategoriesDTO) {
  return (
    category.subtype === UIDAPresentationTypeEnum.collection &&
    category.link.inAppLink?.toLowerCase() === logoInAppLink.toLowerCase()
  );
}
